<template>
  <div class="wrapper">
    <h4 class="success-text">成功授权第三方小程序开发权限</h4>
  </div>
</template>

<script>
export default {
  name: 'wechat_authorize_success'
}
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: center;
  line-height: 200px;
  height: 200px;
}
.success-text {
  color: green;
  font-size: 20px;
}
</style>
